import React, { useState } from 'react';
import useDocument from '../../../hooks/useDocument';
import { IBLSpinLoader } from '../../IBLSpinLoader';
import MediaUpload from '../Forms/MediaUpload';
import { inIframe } from '../../../utils';
import LinkUpload from '../Forms/LinkUpload';

const CareerMedia = ({username, t}) => {
  const [activeTab, setActiveTab] = useState("Tab 1");
  const { documents, documentsDataLoaded, setDocuments, setDocumentsDataLoaded, links, setLinks } = useDocument(username);



  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div
      data-w-tab="Tab 6"
      className={`public-profile-inner-tabs-content-block w-tab-pane w--tab-active`}
      id="w-tabs-0-data-w-pane-6"
      role="tabpanel"
      aria-labelledby="w-tabs-0-data-w-tab-6"
    >
      <div className="div-block-502 _w-100 h-flex">

        {!inIframe() && (
          <div className="w-layout-vflex flex-block-52 left-side" >
            <div className="text-block-272 pr_t">Upload Media</div>
            <div
              data-current="Tab 1"
              data-easing="ease"
              data-duration-in={300}
              data-duration-out={100}
              className="tabs w-tabs"
            >
              <div className="tabs-menu w-tab-menu" role="tablist">
                <a
                  data-w-tab="Tab 1"
                  className={`upload-media-tab w-inline-block w-tab-link ${activeTab === 'Tab 1' ? 'w--current' : ''}`}
                  id="w-tabs-1-data-w-tab-0"
                  href="#w-tabs-1-data-w-pane-0"
                  role="tab"
                  aria-controls="w-tabs-1-data-w-pane-0"
                  aria-selected={activeTab === 'Tab 1'}
                  onClick={(e) => {
                    e.preventDefault()
                    handleTabChange('Tab 1')
                  }}
                >
                  <div>File Upload</div>
                </a>
                <a
                data-w-tab="Tab 2"
                className={`upload-media-tab w-inline-block w-tab-link ${activeTab === 'Tab 2' ? 'w--current' : ''}`}
                tabIndex={-1}
                id="w-tabs-1-data-w-tab-1"
                href="#w-tabs-1-data-w-pane-1"
                role="tab"
                aria-controls="w-tabs-1-data-w-pane-1"
                aria-selected={activeTab === 'Tab 2'}
                onClick={(e) => {
                  e.preventDefault()
                  handleTabChange('Tab 2')
                }}
              >
                <div>Link Upload</div>
              </a>
              </div>
              <div className="tabs-content w-tab-content">
                <div
                  data-w-tab="Tab 1"
                  className={`tab-pane-tab-1 w-tab-pane ${activeTab === 'Tab 1' ? 'w--tab-active' : ''}`}
                  id="w-tabs-1-data-w-pane-0"
                  role="tabpanel"
                  aria-labelledby="w-tabs-1-data-w-tab-0"
                >
                  <MediaUpload setDocuments={setDocuments} />

                </div>
                <div
                  data-w-tab="Tab 2"
                  className={`w-tab-pane ${activeTab === 'Tab 2' ? 'w--tab-active' : ''}`}
                  id="w-tabs-1-data-w-pane-1"
                  role="tabpanel"
                  aria-labelledby="w-tabs-1-data-w-tab-1"
                >
                  <LinkUpload setLinks={setLinks} links={links} />
                </div>
              </div>
            </div>
          </div>
        )}
     



        <div className="w-layout-vflex flex-block-52">
          <div className="text-block-272 pr_t">Uploaded Media</div>
          <div className="w-layout-hflex profile-media-link-container">
            {documentsDataLoaded ? (
              documents.map((document, index) => (
                <a
                  key={index}
                  href={document.url}
                  className="flex-block-51 w-inline-block"
                >
                  <img
                    src="https://cdn.prod.website-files.com/6596e21ac435cac3c66baad8/66e98da687b7d1d5b25714d9_file-text.svg"
                    loading="lazy"
                    alt=""
                    className="image-231"
                  />
                  <div className="text-block-404">
                    {document.name.split('/').pop()}

                  </div>
                </a>
              ))
            ) : (
              <IBLSpinLoader size={40} />
            )}
            {links.map((link, index) => (
              <a
                key={index}
                id="w-node-_8aa6f76e-0d22-56e6-7938-a967dd4dbca4-3cf07fbf"
                href={link?.url}
                className="flex-block-51 w-inline-block"
              >
                <img
                  loading="lazy"
                  src="https://cdn.prod.website-files.com/6596e21ac435cac3c66baad8/66ed860c10f9f025ec432c3b_link%20(1).svg"
                  alt=""
                  className="image-232"
                />
                <div className="text-block-404">{link?.url}</div>
              </a>

            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareerMedia;